import { PencilSquareIcon } from "@heroicons/react/24/solid";

export default function ProfileCard({
    title,
    emptyMessage,           // 강조 문구
    message,                // 일반 문구    
    helper,                 // 추가 설명
    actionText,             // 버튼 라벨
    onAction,               // 버튼 클릭 핸들러
    children,               // 값이 있을 때 요약 내용을 직접 렌더
    profile,
    onEdit
}) {
    const isEmpty = !children;
    const notes = profile?.issues ?? [];

    return (
        <div
            className="
                px-5 py-4 md:px-7 md:py-6
                bg-white rounded-2xl border border-gray-200
                flex flex-col items-center justify-center
            "
        >
            <div className="w-full flex items-center justify-between font-semibold text-lg md:text-xl">
                {title}

                {typeof onEdit === "function" && (
                    <button
                        type="button"
                        onClick={onEdit}
                        aria-label="편집"
                        className=" rounded-md hover:bg-gray-50 active:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#5F9BFF]"
                    >
                        <PencilSquareIcon className="w-5 h-5 md:w-6 md:h-6 text-gray-500" />
                    </button>
                )}
            </div>

            <hr className="w-full my-2.5 md:my-3.5" style={{ border: "1px solid #F1F1F1" }} />

            {profile ? (
                <div className="w-full">
                    <dl className="
                            grid grid-cols-[5.5rem,1fr]   
                            gap-y-2 md:gap-y-2.5
                            text-sm md:text-base
                            ">
                        <dt className="text-gray-500">키</dt>
                        <dd className="font-semibold">
                            {profile?.height_cm != null ? `${profile.height_cm}cm` : "-"}
                        </dd>

                        <dt className="text-gray-500">몸무게</dt>
                        <dd className="font-semibold">
                            {profile?.weight_kg != null ? `${profile.weight_kg}kg` : "-"}
                        </dd>


                        <dt className="text-gray-500">특이사항</dt>
                        <dd className="font-semibold break-keep whitespace-normal leading-relaxed">
                            {notes.length ? notes.join(", ") : "-"}
                        </dd>
                    </dl>
                </div>
            ) :
                <div className="flex flex-col items-center space-y-3.5 w-full">
                    {isEmpty ? (
                        <>
                            {emptyMessage && (
                                <div className="font-semibold text-base md:text-lg">
                                    <div><span className="text-[#ED6363]">{emptyMessage}</span>{message}</div>
                                </div>
                            )}
                            {helper && (
                                <p className="text-sm md:text-base text-gray-500 text-center px-10 ">
                                    {helper}
                                </p>
                            )}
                        </>
                    ) : (
                        <div className="space-y-2">{children}</div>
                    )}

                    {actionText && (
                        <button
                            type="button"
                            onClick={onAction}
                            className="
                        w-full bg-[#5F9BFF] hover:bg-[#4A8AFF]
                        text-white rounded-lg
                        py-1.5 md:py-2
                        active:scale-[.99] transition
                        text-base md:text-lg
                        "
                        >
                            {actionText}
                        </button>
                    )}
                </div>

            }
        </div>
    );
}
